// extracted by mini-css-extract-plugin
module.exports = {"alarm_page_wrapper":"AlarmPage_alarm_page_wrapper__mzVSG"};